import React from 'react';
import { motion } from 'framer-motion';
export interface EqualSharingVisualProps {
  total: number;
  parts: number;
  perPart: number;
  unit?: string;
  label?: string;
  mode?: 'stimulus' | 'support';
}
export function EqualSharingVisual({
  total,
  parts,
  perPart,
  unit = '',
  label,
  mode = 'stimulus'
}: EqualSharingVisualProps) {
  const nf = new Intl.NumberFormat('nl-NL', {
    maximumFractionDigits: 3
  });
  const formattedTotal = nf.format(total);
  const formattedPerPart = nf.format(perPart);
  const displayUnit = unit ? ` ${unit}` : '';
  // Generate an array of parts for rendering
  const segments = Array.from({
    length: parts
  }, (_, i) => i);
  // Colors for alternating segments to make them distinct but cohesive
  const colors = ['bg-blue-100 border-blue-200 text-blue-800', 'bg-indigo-100 border-indigo-200 text-indigo-800', 'bg-violet-100 border-violet-200 text-violet-800', 'bg-purple-100 border-purple-200 text-purple-800'];
  return <div className="w-full max-w-2xl mx-auto flex flex-col items-center py-4" data-id="element-7912">
      {/* Optional Top Label */}
      {label && <div className="text-sm font-medium text-slate-600 mb-4 text-center" data-id="element-7913">
          {label}
        </div>}

      {/* Total Amount Bracket/Label */}
      <div className="w-full relative mb-2" data-id="element-7914">
        <div className="flex justify-center items-end pb-1" data-id="element-7915">
          <span className="text-base font-bold text-slate-700 bg-white px-3 z-10" data-id="element-7916">
            Totaal: {formattedTotal}
            {displayUnit}
          </span>
        </div>
        {/* Bracket line */}
        <div className="absolute bottom-0 left-0 right-0 h-3 border-t-2 border-l-2 border-r-2 border-slate-300 rounded-t-md" data-id="element-7917" />
      </div>

      {/* The Bar */}
      <div className="w-full flex h-14 rounded-lg overflow-hidden border-2 border-slate-300 shadow-sm" data-id="element-7918">
        {segments.map(index => {
        const colorClass = colors[index % colors.length];
        return <motion.div key={index} initial={{
          opacity: 0,
          scaleY: 0
        }} animate={{
          opacity: 1,
          scaleY: 1
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: 'easeOut'
        }} className={`flex-1 flex items-center justify-center border-r last:border-r-0 ${colorClass}`} data-id="element-7919">
              <span className="font-semibold text-sm sm:text-base whitespace-nowrap px-1" data-id="element-7920">
                {mode === 'stimulus' ? '?' : formattedPerPart}
              </span>
            </motion.div>;
      })}
      </div>

      {/* Bottom Summary */}
      <div className="mt-4 text-sm text-slate-500 font-medium flex items-center gap-2" data-id="element-7921">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-slate-100 text-slate-600 border border-slate-200" data-id="element-7922">
          {parts}
        </span>
        gelijke delen van {mode === 'stimulus' ? '?' : formattedPerPart}
        {displayUnit}
      </div>
    </div>;
}